export default __webpack_public_path__ + "static/media/sep2023-2.bb48dd4e.jpg";